export const NODE_SEPARATION_HORIZONTAL = 70;
export const NODE_SEPARATION_VERTICAL = 35;

export enum DrawDesign {
  INTEGRAL_SHAPE = 'integral-shape',
  STRAIGHT = 'line'
}

export const DEFAULT_TASK_NODE_TYPE = 'DEFAULT_TASK_NODE';
export const DEFAULT_SPACER_NODE_TYPE = 'DEFAULT_SPACER_NODE';
export const DEFAULT_EDGE_TYPE = 'DEFAULT_EDGE';
export const DEFAULT_FINALLY_NODE_TYPE = 'DEFAULT_FINALLY_NODE';
